import { useEffect, useState } from 'react';
import { getBWVariant } from './analytics';
import { captureExceptionWithRecording } from './utils';
import { ExperimentVariant, ExperimentVariantObject, IError } from './types';

export function useBWExperiment(
  experimentAPIName: string,
  variants: ExperimentVariantObject<string | undefined>,
  isQualifiedUser = true,
) {
  const [variant, setVariant] = useState<ExperimentVariant>();

  useEffect(() => {
    async function getExperiment() {
      try {
        const bwVariant = (await getBWVariant(experimentAPIName)) as any;
        const { apiName } = bwVariant || {};
        const entry = Object.entries(variants).find(([, val]) => val === apiName) as
          | [ExperimentVariant, string]
          | undefined;

        if (entry) {
          setVariant(entry[0]);
        } else {
          setVariant('');
          delete bwVariant?.experiment?.layer?.experiments;
          delete bwVariant?.experiment?.variants;

          captureExceptionWithRecording(
            new Error(`Invalid BW variant ${apiName} in experiment ${experimentAPIName}`),
            { type: 'BW variant object', variant: JSON.stringify(bwVariant) },
          );
        }
      } catch (e) {
        setVariant('');
        captureExceptionWithRecording(e as IError);
      }
    }
    if (isQualifiedUser) {
      getExperiment();
    }
  }, [experimentAPIName, isQualifiedUser]);

  return variant;
}
